export default __webpack_public_path__ + "static/media/grafema_ss-wedding-identity_12.ffe5b7cc.jpg";